/*
  AuthModal — header "Sign in" entry-point. Lightweight wrapper around
  AuthForm with dialog chrome. Uses Shadcn Dialog for consistent a11y.
*/
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import AuthForm from "./AuthForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

export default function AuthModal({ open, onOpenChange, initialMode = "login" }) {
  const [mode, setMode] = useState("auth"); // auth | forgot
  const [forgotEmail, setForgotEmail] = useState("");

  function close() { onOpenChange(false); setMode("auth"); }

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) setMode("auth"); onOpenChange(v); }}>
      <DialogContent data-testid="auth-modal" className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tighter text-2xl">
            {mode === "forgot" ? "Reset your password" : "Welcome to VeriHandi"}
          </DialogTitle>
          <DialogDescription>
            {mode === "forgot"
              ? "Enter your email and we'll send you a reset link."
              : "Sign in to sync your data across devices."}
          </DialogDescription>
        </DialogHeader>
        {mode === "auth" ? (
          <AuthForm
            initialMode={initialMode}
            onDone={close}
            onForgot={(email) => { setForgotEmail(email); setMode("forgot"); }}
          />
        ) : (
          <ForgotPasswordForm
            initialEmail={forgotEmail}
            onBack={() => setMode("auth")}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
